import React from 'react';
import cx from './cx';

const VARIANT_CLASS = {
  primary: 'rg-btn--primary',
  secondary: 'rg-btn--secondary',
  success: 'rg-btn--success',
  danger: 'rg-btn--danger',
  warning: 'rg-btn--warning',
  info: 'rg-btn--info',
  ghost: 'rg-btn--ghost',
  link: 'rg-btn--link',
  outlinePrimary: 'rg-btn--outline-primary',
  outlineSecondary: 'rg-btn--outline-secondary',
  outlineSuccess: 'rg-btn--outline-success',
  outlineDanger: 'rg-btn--outline-danger',
  outlineWarning: 'rg-btn--outline-warning',
  outlineInfo: 'rg-btn--outline-info',
  lightPrimary: 'rg-btn--light-primary'
};

const SIZE_CLASS = {
  sm: 'rg-btn--sm',
  base: '',
  lg: 'rg-btn--lg'
};

function Button({
  as: Component = 'button',
  variant = 'primary',
  size = 'base',
  fullWidth = false,
  className,
  children,
  disabled,
  type = 'button',
  ...props
}) {
  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={Component === 'button' ? disabled : undefined}
      aria-disabled={disabled || undefined}
      className={cx(
        'rg-btn',
        'rg-focusable',
        'rg-touch-target',
        VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
        SIZE_CLASS[size] || '',
        fullWidth && 'rg-btn--full',
        disabled && 'rg-is-disabled',
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}

export default Button;
